import { createErrorNotification, createLoadingNotification, createSuccessNotification, } from './actionCreators';
import { useToastStore } from './store';
/**
 * The functions in this module are provided for the case when
 * the calling code is outside of React.
 *
 * The preferred way to consume and update toasts is via the provided hooks.
 */
var setToast = function (toast) {
    useToastStore.getState().setToast(toast);
};
export var UnreactiveActionCreators = {
    clearNotification: function () {
        setToast(undefined);
    },
    createErrorNotification: function (message, actionButtonInfo) {
        setToast(createErrorNotification(message, actionButtonInfo));
    },
    createLoadingNotification: function (message, actionButtonInfo) {
        setToast(createLoadingNotification(message, actionButtonInfo));
    },
    createSuccessNotification: function (message, actionButtonInfo, linkInfo) {
        setToast(createSuccessNotification(message, actionButtonInfo, linkInfo));
    },
};
//# sourceMappingURL=unreactive.js.map